import { MultiStepStepLayout } from 'components/MultiStepFlow/MultiStepStepLayout/MultiStepStepLayout'
import { useBrandPlan } from 'hooks/queries/brandPlans/useBrandPlan'
import { BrandAwarenessPlan } from './BrandPlanAwareness'
import { BrandAwarenessPlanStepProps } from './Types'
import Styles from './BrandPlanAwarenessStep.module.scss'

export const BrandPlanAwarenessStep = ({ id, ...rest }: BrandAwarenessPlanStepProps) => {
  const { data: brandPlan } = useBrandPlan(id, { cacheTime: 60 * 1000 * 5 })

  if (!brandPlan) return null

  return (
    <MultiStepStepLayout title="Review topics for your first week" scrollContainerClassName={Styles.scrollContainer}>
      <BrandAwarenessPlan brandPlan={brandPlan} {...rest} />
    </MultiStepStepLayout>
  )
}
